// extracted by mini-css-extract-plugin
export default {"wrapper":"BookContent_wrapper__OHErH"};